import React from 'react';
import { shallow, ShallowWrapper } from 'enzyme';
import JobInterestsModalContainer from './JobInterestsModalContainer';
import profileDummy from '__fixtures__/profile_dummy';

const createProps = () => ({
  profileForm: profileDummy,
  handleFormChange: jest.fn(),
  handleSubmit: jest.fn(),
  categoriesList: profileDummy.categories,
  countriesList: profileDummy.citizenships,
});

let props;
let wrapped: ShallowWrapper;

describe('Your description here', () => {
  beforeEach(() => {
    props = createProps();
    wrapped = shallow(<JobInterestsModalContainer {...props} />);
  });

  it('shallow renders without crashing', () => {
    expect(wrapped.exists()).toBe(true);
  });
});

test.todo('add more tests');
